import styled from 'styled-components';

const MessageList = styled.ul`
  flex-grow: 1;
  padding: 0;
  overflow-y: auto;
`;

export default MessageList;
